import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import axios from 'axios';
import { FaArrowRight } from 'react-icons/fa';

const Category = () => {
    const { name } = useParams(); // ✅ param from `/categories/:name`

    const [categories, setCategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [catsRes, subcatsRes] = await Promise.all([
                    axios.get('https://api.glocart.in/pages/api/api/categories'),
                    axios.get('https://api.glocart.in/pages/api/api/subcategories'),
                ]);

                const catsData = Array.isArray(catsRes.data) ? catsRes.data : (catsRes.data.data || []);
                const subcatsData = Array.isArray(subcatsRes.data) ? subcatsRes.data : (subcatsRes.data.data || []);

                setCategories(catsData);
                setSubcategories(subcatsData);

                // Set selected category name from URL
                if (name) {
                    setSelectedCategory(decodeURIComponent(name));
                }
            } catch (err) {
                console.error('Error fetching data:', err);
            }
        };

        fetchData();
    }, [name]);

    // ✅ Filter subcategories by category name
    const filteredSubcategories = subcategories.filter(
        sub => !selectedCategory || sub.category_name === selectedCategory
    );

    const navigate = useNavigate();

    const handleSubcategoryClick = (sub) => {
        // Navigate to /food/:superCatName/:subCatName
        const superCat = encodeURIComponent(sub.category_name);
        const subCat = encodeURIComponent(sub.subCategory);
        navigate(`/food/${superCat}/${subCat}`);
    };

    return (
        <>
            <Header />
            <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 20px' }}>
                <h4 style={{ textTransform: 'uppercase' }}>{selectedCategory ? `${selectedCategory} – Subcategories` : 'All Subcategories'}</h4>
                {/* Subcategories Grid */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '20px' }}>
                    {filteredSubcategories.length ? (
                        filteredSubcategories.map(sub => (
                            <div key={sub.id} onClick={() => handleSubcategoryClick(sub)} style={{ padding: '10px', textAlign: 'center', }}>
                                <img src={sub.image_sub || 'https://via.placeholder.com/220'} alt={sub.subCategory} style={{ width: '100%', height: '220px', objectFit: 'cover', marginBottom: '12px' }} />
                                <p style={{ fontSize: '16px', color: '#333', fontWeight: '600', margin: 0 }}>{sub.subCategory}</p>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', fontSize: '14px', fontWeight: '600', color: '#000000ff', textDecoration: 'underline', cursor: 'pointer' }}>
                                    <span>View Collection</span>
                                    <FaArrowRight size={14} />
                                </div>

                            </div>
                        ))
                    ) : (
                        <p>No subcategories found for this category.</p>
                    )}
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Category;
